<template>
  <div class="introduction">
    <h2>
      <span>安邦</span>迪博制药
    </h2>
    <p
      class="font14"
    >安邦制药子公司湖南迪博制药是中国最大、最知名的人工牛黄研发和生产企业，其生产的人工牛黄因为质量上乘、服务专业，一直保持行业第一的地位。公司是有四十多年生化药品及其原料生产历史，人工牛黄为公司原料药主打产品，目前年生产能力200吨，产销量已超过100吨，覆盖全国二十多个省、区二百余家药品生产经营企业，与上药集团、同仁堂药业、广药众生药业、玉林制药、亚宝药业、葵花药业等多家知名药企建立了合作关系，产品取得用户信赖。</p>
    <p
      class="font14"
    >近年来，迪博制药正在专注于生化原料药物的产业布局。迪博制药厂区占地22600m²，建有原料药车间、固体制剂车间及研发试验楼，拥有生化原料药提取、人工牛黄两条原料药生产线和颗粒剂、胶囊剂、片剂三条药品制剂生产线。2004年竣工整体通过药品GMP认证并投产，2014年、2019年又先后两次通过药品GMP认证。</p>
    <p class="font14">公司药品制剂产品常年生产品种十余个，包括：抗感冒药系列、消化系统用药系列及血液系统用药系列。</p>
    <p
      class="font14"
    >公司已发展为集药品研发、生产、经营及服务为一体的现代化医药企业，被指定为浏阳经济技术开发区科技产业中试基地和公共实验大楼，受邀为人工牛黄及其原料生产质量标准提升的合作企业，“迪博”牌注册商标连续两次被评为湖南省著名商标。</p>
  </div>
</template>

<script>
export default {
  name: "dibo"
};
</script>

<style lang="stylus">
.introduction {
  h2 {
    font-weight: normal;
    margin-bottom: 12px;
    color: #ED822A;
    font-size: 36px;

    span {
      color: #1278C6;
    }
  }

  .in_right {
    padding-left: 20px;
    margin-bottom: 49px;
  }

  p {
    line-height: 30px;
  }
}
</style>